<template>
	<div
		class="ao-popup-layout"
	>
		<div
			v-if="isLoading"
			class="d-flex align-center justify-center h-100 w-100"
			style="min-height: 6rem;"
		>
			<v-progress-circular
				indeterminate
				color="primary"
				width="3"
				size="32"
			/>
		</div>
		<template
			v-else-if="isLoaded"
		>
			<PopupHeader
				tile
				:title="popupTitle"
			/>

			<slot name="default"/>

			<PopupActions
				:actions="actions"
				@action="$emit('click:action', $event)"
			/>
		</template>
	</div>
</template>

<script setup>

/* const props =  */defineProps({

	isLoading: {
		type: Boolean,
		default: false,
	},

	isLoaded: {
		type: Boolean,
		default: false,
	},

	popupTitle: {
		type: String,
		default: null,
	},

	actions: {
		type: Array,
		default: () => ([]),
	},

})

defineEmits({
	'click:action': null,
})

const onActionClick = () => {}
</script>
